import { useState } from "react";
import Message from "../../../../i18n/Message";
import ModalDialog from "../../../shared/ModalDialog";
import "./RegenerateAboutDialog.scss";
import label from "../../../../i18n/label";
import { useIntl } from "react-intl";
import { RotateCwIcon } from "lucide-react";
import Spinner from "../../../../assets/icons/Spinner";
import backend from "../../../../backend/backend";
import Notify from "../../../shared/Notify";
import { useDispatch } from "react-redux";
import { loadMcpPlaygrounds } from "../../store/mcpPlaygroundActionCreators";
const RegenerateAboutDialog = ({ onClose, playground }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [formElem, setFormElem] = useState(null);
  const [prompt, setPrompt] = useState("");
  const [loading, setLoading] = useState(false);

  const onRegenerate = () => {
    setLoading(true);

    backend
      .regenerateAbout(playground.uid, { prompt })
      .then(() => {
        dispatch(loadMcpPlaygrounds(intl));
        setLoading(false);
        onClose();
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        Notify.error(label(intl, "error_unexpected"));
      });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    onRegenerate();
  };

  return (
    <ModalDialog className="regenerate_about_dialog" onClose={onClose}>
      <div className="modal_title">
        <Message id="regenerate_about_dialog_title" />
      </div>
      <form onSubmit={onSubmit} ref={(val) => setFormElem(val)}>
        <div className="dialog_body_row">
          <p>
            <Message id="regenerate_about_prompt_label" />
          </p>
          <textarea
            id="regenerate_about_prompt"
            rows="3"
            onChange={(e) => setPrompt(e.target.value)}
            value={prompt}
            placeholder={label(intl, "regenerate_about_prompt_placeholder")}
            className="form-control"
            readOnly={loading}
          ></textarea>
        </div>

        <div className="buttons">
          <button
            className="btn bg-gradient-dark"
            disabled={loading}
            onClick={onRegenerate}
          >
            {loading ? <Spinner size="18" /> : <RotateCwIcon size={16} />}

            <Message id="regenerate" />
          </button>
          <button className="btn no-btn" onClick={onClose}>
            <Message id="cancel" />
          </button>
        </div>
      </form>
    </ModalDialog>
  );
};

export default RegenerateAboutDialog;
